import ChatStyles from '../Chat.module.css';

const TabLink = ({ onClick, label, active, notification }) => {
  return (
    <button
      onClick={onClick}
      className={active ? [ChatStyles.chatLists_tab_link, ChatStyles.chatLists_tab_link_active].join(' ') : ChatStyles.chatLists_tab_link}
    >
      {label}
      {notification && <span>{notification}</span>}
    </button>
  );
};

export default TabLink;
